module.exports = __webpack_public_path__ + "static/img/get_un_chocolate.12d110c6.png";